// extracted by css-extract-rspack-plugin
export default {"geoSwitcherText":"geo-switcher-text--kroZ85utIA8Kzm0C","geoSwitcherTextHiddenOnS":"geo-switcher-text_hidden-on-s--yHom9XKBAykTvbhz"};